// Copyright (c) 2016 Deere & Company

const defaultTheme = '01';

const themesMap = {
    '01': '',
    '02': 'cf',
    '03': 'hitachi'
};

const faviconMap = {
    '01': 'deere.ico',
    '02': 'deerecf.ico',
    '03': 'hitachi.ico'
};

export const getThemeClass = themeKey => themesMap[themeKey] || themesMap[defaultTheme];

export const getFaviconUrl = themeKey => faviconMap[themeKey] || faviconMap[defaultTheme];



// WEBPACK FOOTER //
// ./src/user/shared/services/themes.js